import {
  setFiles,
  setProcessingFiles,
} from "slices/workspace/chooseFilesModalSlice";

import { createHandleContinue } from "./upload/orchestrator";
import {
  formatFiles as formatIncomingFiles,
  generateHashes,
  removeDuplicates,
} from "./utils";

export const createUploadContinueHelper = ({
  selectedCollection,
  files,
  activeSource,
  dispatch,
}) => {
  const handleContinue = createHandleContinue({
    context: { selectedCollection },
  });

  const processFiles = async (incomingFiles) => {
    dispatch(setProcessingFiles(true));

    const existingFiles = files;
    let processedFiles = formatIncomingFiles(incomingFiles, activeSource);
    processedFiles = await generateHashes(processedFiles);
    processedFiles = removeDuplicates(processedFiles, existingFiles);

    if (!processedFiles.length) {
      dispatch(setProcessingFiles(false));
      return;
    }

    dispatch(setFiles(existingFiles.concat(processedFiles)));

    dispatch(setProcessingFiles(false));
  };

  return {
    handleContinue,
    processFiles,
  };
};
